export default "__VITE_ASSET___QTTMZEP__"